<template>
  <div class="all-results-component-mobile py-[16px] rounded-[10px]" v-if="allSearchData && allSearchData.length > 0">
    <div class="bg-[#FFFFFF] w-full max-w-full mx-auto p-[12px] rounded-[10px]">
      <div v-if="type === uiTypes.account" class="mb-[8px]">
        <h2 class="text-lg font-bold mb-3 text-blue-light">
          {{ allSearchData.length > 1 ? 'Accounts' : 'Account' }}
          &#x2022;
          {{ allSearchData.length }}
        </h2>
        <AllAccountsList :accounts="{ items: allSearchData }" />
      </div>

      <div v-if="type === uiTypes.block" class="mb-[8px]">
        <h2 class="text-lg font-bold mb-3 text-blue-light">
          {{ allSearchData.length > 1 ? 'Blocks' : 'Block' }}
          &#x2022;
          {{ allSearchData.length }}
        </h2>
        <AllBlocksList :blocks="{ items: allSearchData }" />
      </div>

      <div v-if="type === uiTypes.transaction" class="mb-[8px]">
        <h2 class="text-lg font-bold mb-3 text-blue-light">
          {{ allSearchData.length > 1 ? 'Transactions' : 'Transaction' }}
          &#x2022;
          {{ allSearchData.length }}
        </h2>
        <AllTransactionsList :transactions="{ items: allSearchData }" />
      </div>

      <div v-if="type === uiTypes.token" class="mb-[8px]">
        <h2 class="text-lg font-bold mb-3 text-blue-light">
          {{ allSearchData.length > 1 ? 'Tokens' : 'Token' }}
          &#x2022;
          {{ allSearchData.length }}
        </h2>
        <AllTokensList :tokens="{ items: allSearchData }" />
      </div>

      <div v-if="type === uiTypes.asset" class="mb-[8px]">
        <h2 class="text-lg font-bold mb-3 text-blue-light">
          {{ allSearchData.length > 1 ? 'Assets' : 'Asset' }}
          &#x2022;
          {{ allSearchData.length }}
        </h2>
        <AllAssetsList :assets="{ items: allSearchData }" />
      </div>

      <div v-if="type === uiTypes.nft" class="mb-[8px]">
        <h2 class="text-lg font-bold mb-3 text-blue-light">
          {{ allSearchData.length > 1 ? 'NFTs' : 'NFT' }}
          &#x2022;
          {{ allSearchData.length }}
        </h2>
        <AllNFTsList :nfts="{ items: allSearchData }" />
      </div>

      <div v-if="type === uiTypes.chain" class="mb-[8px]">
        <h2 class="text-lg font-bold mb-3 text-blue-light">
          {{ allSearchData.length > 1 ? 'Chains' : 'Chain' }}
          &#x2022;
          {{ allSearchData.length }}
        </h2>
        <AllChainsList :chains="{ items: allSearchData }" />
      </div>

      <div v-if="type === uiTypes.meta" class="mb-[8px]">
        <h2 class="text-lg font-bold mb-3 text-blue-light">
          {{ allSearchData.length > 1 ? 'Metadatas' : 'Metadata' }}
          &#x2022;
          {{ allSearchData.length }}
        </h2>
        <AllMetadatasList :metadatas="{ items: allSearchData }" />
      </div>
    </div>

    <div v-if="loading" class="flex justify-center py-6">
      <div class="animate-spin rounded-full h-7 w-7 border-b-2 border-blue-light"></div>
    </div>
  </div>
</template>

<script>
import api from '@/helpers/api';
import AllTransactionsList from '@/components/common/AllTransactionsList.vue';
import AllBlocksList from '@/components/common/AllBlocksList.vue';
import AllAccountsList from '@/components/common/AllAccountsList.vue';
import AllTokensList from '@/components/common/AllTokensList.vue';
import AllAssetsList from '@/components/common/AllAssetsList.vue';
import AllNFTsList from '@/components/common/AllNFTsList.vue';
import AllMetadatasList from '@/components/common/AllMetadatasList.vue';
import AllChainsList from '@/components/common/AllChainsList.vue';
import { UiTypes } from '@/utils/uiTypes';

export default {
  name: 'AllResultsComponentMobile',
  components: {
    AllTransactionsList,
    AllBlocksList,
    AllAccountsList,
    AllTokensList,
    AllAssetsList,
    AllNFTsList,
    AllMetadatasList,
    AllChainsList,
  },
  data() {
    return {
      uiTypes: UiTypes,
      loading: false,
      hasMoreData: true,
      currentOffset: 0,
      limit: 10,
      allSearchData: [],
    };
  },
  computed: {
    type() {
      return this.$route.params.type;
    },
    searchQuery() {
      return this.$route.query.value || '';
    },
  },
  created() {
    this.fetchData();
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    fetchData(loadMore = false) {
      if (this.loading) return;

      this.loading = true;
      const offset = loadMore ? this.currentOffset : 0;
      const searchType = this.type || 'all';

      api.searchBlockchainBySearchType(searchType, this.searchQuery, this.limit, offset)
        .then(response => {
          const res = response.data;

          if (res.result && res.result.items && res.result.items.length > 0) {
            if (loadMore) {
              this.allSearchData = [...this.allSearchData, ...res.result.items];
            } else {
              this.allSearchData = res.result.items;
            }

            this.currentOffset += this.limit;
            this.hasMoreData = res.result && res.result.total.value > this.currentOffset;
            this.loading = !!this.hasMoreData;
          } else {
            this.hasMoreData = false;
          }
        })
        .catch(() => {
          this.hasMoreData = false;
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 1200);
        });
    },
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      if (scrollTop + windowHeight >= documentHeight - 200) {
        if (this.hasMoreData && !this.loading) {
          this.fetchData(true);
        }
      }
    },
  },
};
</script>

<style scoped>
.all-results-component-mobile {
  width: 100%;
}
</style>
